require("imports-loader?this=>window!./vendor/js/jquery.events.touch.min.js");


import './vendor/js/lightcase';
import './vendor/css/lightcase.css';


$(document).ready(function($) {

  $('a[data-rel^=lightcase]').lightcase({swipe: true});

});